import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
} from '@mui/material';
import {
  Campaign,
  WhatsApp,
  Instagram,
  TrendingUp,
  LinkedIn,
  Twitter,
} from '@mui/icons-material';

const MarketingOverview: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const StatCard = ({ title, value, icon, color, onClick }: any) => (
    <Card elevation={2} sx={{ cursor: onClick ? 'pointer' : 'default', '&:hover': onClick ? { boxShadow: 6 } : {} }} onClick={onClick}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Avatar sx={{ bgcolor: color, width: 48, height: 48 }}>{icon}</Avatar>
        </Box>
        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 0.5 }}>{value}</Typography>
        <Typography color="text.secondary" variant="body2">{title}</Typography>
      </CardContent>
    </Card>
  );

  return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>{t('marketing.overview')}</Typography>

        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' }, gap: 3 }}>
          <StatCard title={t('marketing.whatsappCampaigns')} value={t('common.active')} icon={<WhatsApp />} color="success.main" onClick={() => navigate('/operations/whatsapp-chat')} />
          <StatCard title={t('marketing.instagramPosts')} value={t('common.view')} icon={<Instagram />} color="error.main" onClick={() => navigate('/instagram')} />
          <StatCard title={t('marketing.linkedin')} value={t('marketing.comingSoon')} icon={<LinkedIn />} color="#0077B5" onClick={() => navigate('/marketing/linkedin')} />
          <StatCard title={t('marketing.twitter')} value={t('marketing.comingSoon')} icon={<Twitter />} color="#1DA1F2" onClick={() => navigate('/marketing/twitter')} />
          <StatCard title={t('marketing.campaigns')} value={t('marketing.comingSoon')} icon={<Campaign />} color="info.main" onClick={() => navigate('/marketing/campaigns')} />
          <StatCard title={t('marketing.performance')} value={t('marketing.analytics')} icon={<TrendingUp />} color="primary.main" />
        </Box>
      </Box>
  );
};

export default MarketingOverview;

